/* eslint-disable sonarjs/cognitive-complexity */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Formik } from 'formik';
import { PropTypes } from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Col, Row } from 'antd';
import { capitalize, isEmpty } from 'lodash';
import { Form, Select, Checkbox, Radio } from 'formik-antd';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { Box, FormInput, Button, CustomInput } from 'atoms';
import { addProject } from 'store/projectSlice';
import { ACL, BoxMod, EditModeBtn, ImageView } from 'components/common';
import { Debug } from './Debug';
import { getClientList } from 'store/clientSlice';
// import { useQuery } from 'hooks';
import FilesUploadS3 from 'components/common/FilesUploadS3';
import {
	contractOptions,
	DATE_FORMAT,
	day_wise_options,
	docimgpdffileformates,
	docimgpdffiletypetoShow,
} from 'utils/config';
import { CancelButton, DatePickers } from 'utils/commonStyled';

const FormSchema = Yup.object({
	contract_type: Yup.string().min(3).max(200).label('Contract Type'),
	contract_date: Yup.date().required().label('Start Date'),
	expiry_date: Yup.date()
		.required()
		.label('Expiry Date')
		.when(
			'contract_date',
			(contract_date, yup) =>
				contract_date && yup.min(contract_date, 'End Date cannot be before Start Date')
		),
	client_id: Yup.string().required().label('Client'),
	project_id: Yup.array().required().label('Project'),
	vehicle_type: Yup.string().label('Vehicle Category').required(),
	fixed_rate: Yup.number().min(0).max(9999999).typeError('Not a valid Fixed Rate').required(),
	project_loc_codes: Yup.array(),
	extra_charge_per_hr: Yup.number()
		.min(0)
		.max(9999)
		.typeError('Not a valid Extra Charge  Per Hour')
		.required(),
	extra_charge_per_km: Yup.number()
		.min(0)
		.max(9999)
		.typeError('Not a valid Extra Charge  Per KM')
		.required(),
	threshold_km_per_day: Yup.number()
		.min(0)
		.max(9999)
		.typeError('Not a valid threshold KM  Per Day')
		.required(),
	threshold_km_per_month: Yup.number()
		.min(0)
		.max(999999)
		.typeError('Not a valid threshold KM  Per Month')
		.required(),
	wise: Yup.string(),
	city: Yup.string().required(),
	day_wise: Yup.number().label('No of Days').min(0).max(31),
	// .when('wise', (wise, schema) => {
	// 	if (wise === 'day_wise') return schema.required();
	// 	return schema;
	// }),
	month_wise_option: Yup.string().label('Month Wise'),
	// .when('wise', (wise, schema) => {
	// 	if (wise === 'month_wise_option') return schema.required();
	// 	return schema;
	// }),
	no_of_off_days: Yup.number().label('No of Off Day').min(0).max(7),
	// .when(['wise', 'month_wise_option'], (wise, month_wise_option, schema) => {
	// 	if (wise === 'month_wise_option' && month_wise_option === 'off_days')
	// 		return schema.required();
	// 	return schema;
	// }),
	week_off_days: Yup.array().label('No of Week Off').nullable(),
});

const payload_month_wise = {
	sunday: false,
	monday: false,
	tuesday: false,
	wednesday: false,
	thursday: false,
	friday: false,
	saturday: false,
};

const defaultMonth_wiseData = {
	sunday: false,
	monday: false,
	tuesday: false,
	wednesday: false,
	thursday: false,
	friday: false,
	saturday: false,
};

const defaultdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

function getSelectedMonthWise(data) {
	if (data) {
		const monthKeys = [];
		Object.entries(data).forEach(([key, value]) => {
			if (value) {
				monthKeys.push(key);
			}
		});
		console.log('monthKeys', monthKeys);
		return monthKeys;
	}
	return [];
}

function getweekValue(values) {
	console.log(values);
	if (values.month_wise_option === 'week_off') {
		if (values?.week_off_days.length > 0) {
			return payload_month_wise;
		}
		if (values?.week_off_days.length === 0) {
			return defaultMonth_wiseData;
		}
	}
	return {};
}
export default function ClientContractForm({
	isEditMode = false,
	formData = {},
	vehicleData = [],
	cites = [],
}) {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	// const [query] = useQuery();
	const [projectData, setProjects] = useState('');
	const [contractFilesList, setContractFilesList] = useState([]);
	const [project_loccodes, setProjectlocalId] = useState('');
	const [clientsData, setClientsdata] = useState('');
	const [cityVal, setCityVal] = useState('');
	const [editMode, setEditMode] = useState(false);
	const [isCreate, setIsCreate] = useState(false);

	const initialValues = useMemo(
		() => ({
			...(isEditMode && { id: formData?.id }),
			create_type: formData?.create_type || undefined,
			client_id: isEditMode ? formData?.client_name : formData?.client_id || undefined,
			contract_type: 'km_based',
			contract_date: formData?.contract_date || undefined,
			expiry_date: formData?.expiry_date || undefined,
			fixed_rate: formData?.fixed_rate || undefined,
			project_id: [formData?.project_id] || undefined,
			vehicle_type: formData?.vehicle_type || undefined,
			extra_charge_per_hr: formData?.info?.extra_charge_per_hr || 0,
			extra_charge_per_km: formData?.info?.extra_charge_per_km || 0,
			threshold_km_per_month: formData?.info?.threshold_km_per_month || 0,
			threshold_km_per_day: formData?.info?.threshold_km_per_day || 0,
			project_loc_codes: undefined,
			city: formData?.city || undefined,
			wise:
				formData?.month_wise && !isEmpty(formData.month_wise)
					? 'month_wise_option'
					: 'day_wise' || undefined,
			month_wise_option: formData?.month_wise?.week_off_days ? 'week_off' : 'off_days',
			day_wise: formData?.day_wise || undefined,
			week_off_days: formData?.month_wise?.week_off_days
				? getSelectedMonthWise(formData?.month_wise?.week_off_days)
				: [],
			no_of_off_days: formData?.month_wise?.no_of_off_days || undefined,
		}),
		[formData, isEditMode]
	);

	function useOnceCall(cb, condition = true) {
		const isCalledRef = useRef(false);

		useEffect(() => {
			if (condition && !isCalledRef.current) {
				isCalledRef.current = true;
				cb();
			}
			setIsCreate(location.pathname.split('/').pop() === 'add');
		}, [cb, condition]);
	}

	useOnceCall(() => {
		/**
		 * On Edit mode prefill dropdowns
		 */
		handleClientsChange(formData?.client_id);
		handleCitiesChange(formData?.city);
	});

	function handleCitiesChange(e, setFieldValue) {
		setCityVal(e);
		if (setFieldValue) {
			setFieldValue('client_id', undefined);
		}
		dispatch(
			getClientList({
				search_type: 'client',
				filter_by: {
					project_cities: [e],
				},
			})
		).then((res) => {
			const data = res?.data?.map((item) => ({
				value: item?.id,
				label: item?.client_name,
				item,
			}));
			setClientsdata(data);
		});
	}

	function handleClientsChange(e, setFieldValue) {
		if (setFieldValue) {
			setFieldValue('project_id', undefined);
		}
		dispatch(
			getClientList({
				search_type: 'project',
				filter_by: {
					client_id: e,
					city: cityVal,
				},
			})
		).then((res) => {
			setProjects(
				res?.data?.map((item) => ({
					label: capitalize(item?.project_location_code),
					value: item?.id,
					id: item?.id,
					project_loc_codes: item?.project_loc_codes,
					item,
				}))
			);
			setProjectlocalId(
				res?.data?.map((item) => ({
					id: item?.id,
					project_loc_codes: item?.project_location_code,
				}))
			);
		});
	}

	const handleSubmit = (values, { setErrors, setSubmitting }) => {
		const {
			extra_charge_per_hr,
			extra_charge_per_km,
			threshold_km_per_day,
			threshold_km_per_month,
			fixed_rate,
			contract_date,
			expiry_date,
			month_wise_option,
			day_wise,
			week_off,
			week_off_days,
			client_id,
			...rest
		} = values;

		const locationCode = [];

		defaultdays.forEach((value) => {
			payload_month_wise[value] = false;
		});
		console.log(payload_month_wise);

		// pro location filters
		project_loccodes.forEach((value) => {
			if (values.project_id.includes(value.id)) locationCode.push(value?.project_loc_codes);
		});

		if (
			values.wise === 'month_wise_option' &&
			values.month_wise_option === 'week_off' &&
			values?.week_off_days.length > 0
		) {
			console.log(values?.week_off_days);
			values?.week_off_days.forEach((value) => {
				payload_month_wise[value] = true;
			});
		}

		console.log(payload_month_wise);
		let payload;
		if (isEditMode) {
			payload = {
				update_type: 'client_contract',
				data: {
					...rest,
					client_id: formData?.client_id,
					id: formData?.id,
					contract_document: !isEmpty(contractFilesList)
						? contractFilesList
						: formData?.contract_document,
					fixed_rate: Number(fixed_rate),
					contract_date: moment(contract_date).format(DATE_FORMAT),
					expiry_date: moment(expiry_date).format(DATE_FORMAT),
					project_loc_codes: locationCode,
					...(values.wise === 'day_wise' && {
						day_wise: values.wise === 'day_wise' ? Number(day_wise) : undefined,
					}),

					...(values.wise === 'month_wise_option' && {
						month_wise:
							values.wise === 'month_wise_option'
								? {
										week_off_days: getweekValue(values),
										no_of_off_days:
											values.month_wise_option === 'off_days'
												? Number(values.no_of_off_days)
												: undefined,
								  }
								: undefined,
					}),
					info: {
						extra_charge_per_hr: Number(extra_charge_per_hr),
						extra_charge_per_km: Number(extra_charge_per_km),
						threshold_km_per_day: Number(threshold_km_per_day),
						threshold_km_per_month: Number(threshold_km_per_month),
					},
				},
			};
		} else {
			payload = {
				create_type: 'client_contract',
				data: {
					...rest,
					client_id,
					contract_document: !isEmpty(contractFilesList)
						? contractFilesList
						: formData?.contract_document,
					fixed_rate: Number(fixed_rate),
					contract_date: moment(contract_date).format(DATE_FORMAT),
					expiry_date: moment(expiry_date).format(DATE_FORMAT),
					project_loc_codes: locationCode,
					...(values.wise === 'day_wise' && {
						day_wise: values.wise === 'day_wise' ? Number(day_wise) : undefined,
					}),

					...(values.wise === 'month_wise_option' && {
						month_wise:
							values.wise === 'month_wise_option'
								? {
										week_off_days: getweekValue(values),
										no_of_off_days:
											values.month_wise_option === 'off_days'
												? Number(values.no_of_off_days)
												: undefined,
								  }
								: undefined,
					}),
					info: {
						extra_charge_per_hr: Number(extra_charge_per_hr),
						extra_charge_per_km: Number(extra_charge_per_km),
						threshold_km_per_day: Number(threshold_km_per_day),
						threshold_km_per_month: Number(threshold_km_per_month),
					},
				},
			};
		}

		dispatch(addProject({ data: payload, setErrors, isEditMode }))
			.then(() => {
				setSubmitting(false);
				navigate('/client-contracts');
			})
			.catch(() => {
				setSubmitting(false);
			});
	};

	function handleContractFileUpload(files) {
		setContractFilesList(files);
	}
	function handleEdit() {
		setEditMode(!editMode);
	}
	return (
		<Formik
			initialValues={initialValues}
			validationSchema={FormSchema}
			onSubmit={handleSubmit}
			enableReinitialize
			initialTouched={{
				day_wise: true,
			}}
		>
			{({ values, setFieldValue }) => (
				<Box>
					<ACL action="update" module="client_contract">
						{isEditMode && <EditModeBtn handleEdit={handleEdit} />}
					</ACL>
					<Form className={editMode === false && !isCreate ? 'disabled-div' : ''}>
						<Box padding="1.5rem 2rem" background="#fff">
							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="contract_type" label="Contract type">
										<Select
											showSearch
											onClear
											name="contract_type"
											disabled
											filterOption={(input, option) =>
												option.username
													.toLowerCase()
													.indexOf(input?.toLowerCase()) >= 0
											}
											placeholder="Select"
											options={contractOptions}
										/>
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput name="city" label="Select City *">
										<Select
											showSearch
											onClear
											disabled={isEditMode}
											name="city"
											filterOption={(input, option) =>
												option.label
													.toLowerCase()
													.indexOf(input?.toLowerCase()) >= 0
											}
											options={cites}
											placeholder="Select"
											onChange={(e) => handleCitiesChange(e, setFieldValue)}
										/>
									</FormInput>
								</Col>
							</Row>
							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="client_id" label="Select Client *">
										<Select
											showSearch
											onClear
											disabled={isEditMode || !values?.city}
											name="client_id"
											filterOption={(input, option) =>
												option.label
													.toLowerCase()
													.indexOf(input?.toLowerCase()) >= 0
											}
											options={clientsData}
											placeholder="Select"
											onChange={(e) => handleClientsChange(e, setFieldValue)}
										/>
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput name="project_id" label="Select Project*">
										<Select
											showSearch
											onClear
											mode="multiple"
											name="project_id"
											disabled={isEditMode || !values?.client_id}
											filterOption={(input, option) =>
												option.label
													.toLowerCase()
													.indexOf(input?.toLowerCase()) >= 0
											}
											placeholder="Select"
											options={projectData}
										/>
									</FormInput>
								</Col>
							</Row>
							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="contract_date" label="Contract Date *">
										<DatePickers name="contract_date" format="DD-MM-YYYY" />
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput name="expiry_date" label="Expiry Date *">
										<DatePickers name="expiry_date" format="DD-MM-YYYY" />
									</FormInput>
								</Col>
							</Row>
							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="vehicle_type" label="Select Vehicle Type *">
										<Select
											showSearch
											onClear
											name="vehicle_type"
											disabled={isEditMode}
											filterOption={(input, option) =>
												option.label
													.toLowerCase()
													.indexOf(input?.toLowerCase()) >= 0
											}
											placeholder="Select"
											options={vehicleData}
										/>
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput
										name="extra_charge_per_hr"
										label="Extra charge per hour *"
									>
										<CustomInput
											name="extra_charge_per_hr"
											onClick={(e) => {
												if (e.target.value === '0') {
													e.target.value = '';
												}
											}}
										/>
									</FormInput>
								</Col>
							</Row>
							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="fixed_rate" label="Fixed Rate *">
										<CustomInput name="fixed_rate" />
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput
										name="extra_charge_per_km"
										label="Extra Charge Per Km*"
									>
										<CustomInput
											name="extra_charge_per_km"
											onClick={(e) => {
												if (e.target.value === '0') {
													e.target.value = '';
												}
											}}
										/>
									</FormInput>
								</Col>
							</Row>
							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput
										name="threshold_km_per_day"
										label="Threshold Km Per Day*"
									>
										<CustomInput
											name="threshold_km_per_day"
											onClick={(e) => {
												if (e.target.value === '0') {
													e.target.value = '';
												}
											}}
										/>
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput
										name="threshold_km_per_month"
										label="Threshold Km Per Month *"
									>
										<CustomInput
											name="threshold_km_per_month"
											onClick={(e) => {
												if (e.target.value === '0') {
													e.target.value = '';
												}
											}}
										/>
									</FormInput>
								</Col>
							</Row>

							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="wise" label="">
										<Radio.Group name="wise">
											<Radio value="day_wise">No. of Days (Fix)</Radio>
											<Radio value="month_wise_option">
												No. of Days (Month wise)
											</Radio>
										</Radio.Group>
									</FormInput>
								</Col>
								<Col lg={12}></Col>
							</Row>
							<Row gutter={16} justify="space-between">
								{values?.wise === 'month_wise_option' && (
									<Col lg={12}>
										<FormInput name="month_wise_option" label="">
											<Radio.Group name="month_wise_option">
												<Radio value="off_days">Days off</Radio>
												<Radio value="week_off">Week off</Radio>
											</Radio.Group>
										</FormInput>
									</Col>
								)}
								{values?.wise === 'day_wise' && (
									<Col lg={12}>
										<FormInput name="day_wise" label="No of Days*">
											<CustomInput name="day_wise" />
										</FormInput>
									</Col>
								)}
							</Row>
							{values?.wise === 'month_wise_option' && (
								<Row gutter={16} justify="space-between">
									{values?.month_wise_option === 'off_days' && (
										<Col lg={12}>
											<FormInput
												name="no_of_off_days"
												label="No of off Days*"
											>
												<CustomInput name="no_of_off_days" />
											</FormInput>
										</Col>
									)}
									{values?.month_wise_option === 'week_off' && (
										<Col lg={12}>
											<Col lg={12}>
												<FormInput
													name="week_off_days"
													label="Week Off Days *"
												>
													<Checkbox.Group
														name="week_off_days"
														options={day_wise_options}
													/>
												</FormInput>
											</Col>
										</Col>
									)}
								</Row>
							)}
							<BoxMod></BoxMod>
							<Box border="1px solid #ccc" padding="34px">
								<FilesUploadS3
									entity="client_contract"
									successCallBack={handleContractFileUpload}
									name="Contract document"
									size={8192000}
									fileformates={docimgpdffileformates}
									filetypetoShow={docimgpdffiletypetoShow}
								/>

								{contractFilesList && (
									<ImageView
										entity="client_contract"
										files={formData?.contract_document}
										name="Contract document"
									/>
								)}
							</Box>
						</Box>
						<Box backgroundColor="#f5f5f5" textAlign="right" padding="1.5rem">
							<CancelButton
								onClick={() => navigate('/client-contracts')}
								type="button"
							>
								Cancel
							</CancelButton>
							<Button borderRadius="4px" backgroundColor="#18405d" type="submit">
								{isEditMode ? 'Update' : 'Submit'}
							</Button>
						</Box>
						<Debug />
					</Form>
				</Box>
			)}
		</Formik>
	);
}

ClientContractForm.propTypes = {
	isEditMode: PropTypes.bool,
	formData: PropTypes.object,
	vehicleData: PropTypes.array,
	cites: PropTypes.array,
};
